import { PRIVATE_EVENT_ADD_ONS } from '../../api/privateEvents';
import { TogglePill } from '../dashboards/primitives';
import { Field } from '../dashboards/primitives/Field';

import { COLUMN, NOTE } from './steps/step-layout';
import type { AddOnsNotesForm as Form } from './use-add-ons-notes-form';

export default function AddOnsNotesForm({ form }: { form: Form }) {
  const { draft, set } = form;
  const toggle = (id: string) =>
    set(
      'addOns',
      draft.addOns.includes(id) ? draft.addOns.filter((x) => x !== id) : [...draft.addOns, id],
    );
  return (
    <div style={COLUMN}>
      <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-ink-2)' }}>Add-ons</span>
      <div role="group" aria-label="Add-ons" style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {PRIVATE_EVENT_ADD_ONS.map((a) => (
          <TogglePill
            key={a.id}
            selected={draft.addOns.includes(a.id)}
            onClick={() => toggle(a.id)}
          >
            {a.label}
          </TogglePill>
        ))}
      </div>
      <Field label="Internal notes" hint={<span style={NOTE}>never shown to the client</span>}>
        <textarea
          aria-label="Internal notes"
          rows={3}
          value={draft.notes}
          onChange={(e) => set('notes', e.target.value)}
          style={{
            width: '100%',
            padding: '8px 10px',
            borderRadius: 8,
            fontSize: 12.5,
            lineHeight: 1.45,
            resize: 'vertical',
            fontFamily: 'inherit',
            background: 'var(--nb-bg)',
            color: 'var(--nb-ink)',
            border: '1px solid var(--nb-border-2)',
          }}
        />
      </Field>
    </div>
  );
}
